import { IconButton } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from '@zep-us/zus-icons';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import { type AiBuilderPendingQuestionSetQuestion } from '../store/types';
export type AiBuilderQuestionSetHeaderProps = {
  questionTitleId: string;
  activeQuestionId: string;
  questions: readonly AiBuilderPendingQuestionSetQuestion[];
  onNavigatePrevious: () => void;
  onNavigateNext: () => void;
  onCancel: () => void;
};
export const AiBuilderQuestionSetHeader = ({
  questionTitleId,
  activeQuestionId,
  questions,
  onNavigatePrevious,
  onNavigateNext,
  onCancel
}: AiBuilderQuestionSetHeaderProps) => {
  const copy = useAiBuilderChatCopy();
  const activeIndex = questions.findIndex(question => question.questionId === activeQuestionId);
  const activeQuestion = questions[activeIndex];
  if (!activeQuestion) return null;
  const current = activeIndex + 1;
  const total = questions.length;
  const navigationFocusClassName = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-strong focus-visible:ring-offset-1';
  return <header className="flex flex-col gap-md" data-sentry-component="AiBuilderQuestionSetHeader" data-sentry-source-file="AiBuilderQuestionSetHeader.tsx">
      <div className="flex items-center justify-between gap-sm">
        <div className="flex items-center gap-3xs">
          <IconButton type="button" variant="outlined" intent="neutral" size="2xs" rounded="full" className={navigationFocusClassName} disabled={activeIndex === 0} aria-label={copy.questionSet.navigation.previousQuestionAriaLabel} onClick={onNavigatePrevious} data-sentry-element="IconButton" data-sentry-source-file="AiBuilderQuestionSetHeader.tsx">
            <ChevronLeftIcon aria-hidden="true" size="xs" fill={ICON_COLOR.neutral} data-sentry-element="ChevronLeftIcon" data-sentry-source-file="AiBuilderQuestionSetHeader.tsx" />
          </IconButton>
          <span className="text-center text-body-sm-medium text-neutral" aria-label={copy.questionSet.navigation.progressAriaLabel(current, total)}>
            {copy.questionSet.navigation.progress(current, total)}
          </span>
          <IconButton type="button" variant="outlined" intent="neutral" size="2xs" rounded="full" className={navigationFocusClassName} disabled={activeIndex === total - 1} aria-label={copy.questionSet.navigation.nextQuestionAriaLabel} onClick={onNavigateNext} data-sentry-element="IconButton" data-sentry-source-file="AiBuilderQuestionSetHeader.tsx">
            <ChevronRightIcon aria-hidden="true" size="xs" fill={ICON_COLOR.neutral} data-sentry-element="ChevronRightIcon" data-sentry-source-file="AiBuilderQuestionSetHeader.tsx" />
          </IconButton>
        </div>
        <IconButton type="button" variant="transparent" intent="neutral" size="xs" rounded="default" className={navigationFocusClassName} title={copy.questionSet.navigation.close} aria-label={copy.questionSet.navigation.closeAriaLabel} onClick={onCancel} data-sentry-element="IconButton" data-sentry-source-file="AiBuilderQuestionSetHeader.tsx">
          <XIcon aria-hidden="true" size="sm" fill={ICON_COLOR.neutral} data-sentry-element="XIcon" data-sentry-source-file="AiBuilderQuestionSetHeader.tsx" />
        </IconButton>
      </div>
      <div className="flex flex-col gap-2xs px-xs">
        <h2 id={questionTitleId} className="text-body-lg-bold text-default">
          {activeQuestion.question}
        </h2>
        {activeQuestion.context ? <p className="text-body-sm-regular text-neutral">
            {activeQuestion.context}
          </p> : null}
      </div>
    </header>;
};